import { BcModel } from './../../../shared/models/societe-linked/bc/bc.model';
import { ToastrService } from 'ngx-toastr';
import { SocieteModel } from '../../../shared/models/simple-types/societe.model';
import { SocieteService } from '../../../shared/services/simple/societe.service';
import { BcLineService } from 'src/app/shared/services/bc/bc-line.service';
import { ModalInfoOkComponent } from './../../../shared/components/modals/info-ok/modal-info-ok.component';
import { AfterContentChecked, ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { BehaviorSubject, Observable, Subscription, of } from 'rxjs';
import { UntypedFormArray, FormControl, UntypedFormGroup } from '@angular/forms';
import { BcComponentsService, DetailBcLineinfos, DetailBcinfos } from '../bc-components.service';
import { ActivatedRoute, Router } from '@angular/router';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { StateService } from 'src/app/shared/services/state.service';
import { BcService } from 'src/app/shared/services/bc/bc.service';
import { SpinnerModalComponent } from 'src/app/shared/components/modals/spinner/spinner-modal.component';
import { Title } from '@angular/platform-browser';
import { DocumentModel } from 'src/app/shared/models/simple-types/document.model';
import { ModalCycleValidationComponent } from '../modals/modal-cycle-validation/modal-cycle-validation.component';
import { NTHFlag } from 'src/app/shared/constants/flag';
import { element } from 'protractor';
import { DefinitionDroitsBC } from 'src/app/shared/droitsDefinitions';


@Component({
  selector: 'app-brouillon-enveloppe',
  templateUrl: './brouillon-enveloppe.component.html',
  styleUrls: ['./brouillon-enveloppe.component.scss']
})
export class BrouillonEnveloppeComponent implements OnInit, AfterContentChecked, OnDestroy {

  bcLineForm: UntypedFormGroup;

  bc: BcModel = new BcModel();
  detailBcInfo: DetailBcinfos = new DetailBcinfos();
  observableBc = new BehaviorSubject<BcModel>(null);
  bcForm: UntypedFormGroup;
  documents: DocumentModel[] = [];
  bcLineHTs: number;
  bcLineTVAs: number;
  bcLineTTCs: number;
  articleLib: string;
  ca1: any = null;
  listOfBc: Observable<BcModel>;
  bcId: number;
  bcSociety: SocieteModel = new SocieteModel();
  withoutDoc = false;
  bcLinesKeys = Object.keys;
  bcLineRef: Observable<DetailBcLineinfos>;
  private subscriptions: Subscription[] = [];
  constructor(
    public dialog: MatDialog,
    private router: Router,
    private bcComponentsService: BcComponentsService,
    private route: ActivatedRoute,
    private title: Title,
    private bcLineService: BcLineService,
    private bcService: BcService,
    private stateService: StateService,
    private societeService: SocieteService,
    private toastr: ToastrService,
    private changeDetectorRef: ChangeDetectorRef) {

    this.bcLineHTs = 0;
    this.bcLineTVAs = 0;
    this.bcLineTTCs = 0;
    this.articleLib = '';
    this.bcId = null;
    this.checkIdParameter();
    this.getBcByIdAndSociety();
  }

  ngOnInit(): void {
    this.verifyBcStatusToRedirect();
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(element => {
      element.unsubscribe();
    });
    this.bcComponentsService.purgeDetailBcInfo(); 
  }

  ngAfterContentChecked(): void {
    this.changeDetectorRef.detectChanges();
  }

  close(): void {
    this.router.navigate(['/list-bc/']);
  }

  setSociety(society: SocieteModel): void {
    if (society) {
      this.bcSociety = Object.assign({}, society);
      this.bc.societe = this.bcSociety;
    }
  }

  getAndSetSociety(idSociety: number): Observable<SocieteModel> {
    return this.societeService.get(idSociety);
  }
  getSelectedDocuments(object: any): void {
    this.documents = object;
  }
  setValuesToBc(): void {
    this.bc = this.bcForm.getRawValue();
    this.bc.bcLines = (this.bcForm.get('bcLines') as UntypedFormArray).getRawValue();
    this.bc.idSociete = this.bcForm.controls.idSociete.value;
    this.bc.code = this.bcForm.controls.code.value;
    this.bc.libelle = this.bcForm.controls.libelle.value;
    this.bc.tva = this.bcLineTVAs;
    this.bc.ht = this.bcLineHTs;
    this.bc.ttc = this.bcLineTTCs;
    this.getAndSetSociety(this.bc.idSociete).subscribe((society: SocieteModel) => {
      this.setSociety(society);
    });
  }

  memorize(): void {

    this.setValuesToBc();
    const dialogRef = this.dialog.open(SpinnerModalComponent);

    this.bcComponentsService.memorizeBc(this.bc).subscribe((data: any) => {
    this.bc = data;
    this.getBcByIdAndSociety();
    dialogRef.close();
    }, (error) => dialogRef.close());


    if (!this.bcForm.valid && this.bcForm.getRawValue().bcLines.length >= 1 ) {
      this.displayErrors();
    }
    const formArray: UntypedFormArray = this.bcForm.get('bcLines') as UntypedFormArray;
    for (let i = 0; i < formArray.controls.length; i++) {
      for (const bcLineControl in (formArray.controls[i] as UntypedFormGroup).controls) {
        if ((formArray.controls[i] as UntypedFormGroup).controls[bcLineControl].errors) {
          this.toastr.warning('Veuillez remplir le champ : ' + bcLineControl + ' de la ligne ' + i);
        }
      }
    }
    
  }

  validate(): void {
      if (this.bcForm.valid && this.bcForm.getRawValue().bcLines.length >= 1 && (this.documents.length > 0 || this.withoutDoc) ) {
        this.setValuesToBc();
        const dialogRef = this.dialog.open(SpinnerModalComponent);
        this.bcComponentsService.saveBc(this.bc).subscribe((bc: BcModel) => {
          if (bc) {
            dialogRef.close();
            const dialogConfirmation = this.dialog.open(ModalInfoOkComponent, {
              data: {
                title: 'Voulez-vous créer un autre BC ?',
                message: '',
                color: 'primary'
              }
            });
            return dialogConfirmation.afterClosed().subscribe((res) => {
              if (res) {
                localStorage.setItem('societe', JSON.stringify(this.bcSociety));
                this.router.navigate(['/create-bc']);
              } else {
                dialogRef.close();
                this.router.navigate(['/read-bc/' + bc.id]);
              }
            });
          }
        }, (error) => dialogRef.close());
      }
      if (this.documents.length === 0 && !this.withoutDoc) {
        this.toastr.warning('Veuillez ajouter au moins un document ');
      }
      this.displayErrors();
      const formArray: UntypedFormArray = this.bcForm.get('bcLines') as UntypedFormArray;
      if (formArray.controls.length === 0) {
        this.toastr.warning('Veuillez ajouter au moins une ligne');
      } else {
        // tslint:disable-next-line: prefer-for-of
        for (let i = 0; i < formArray.controls.length; i++) {
          for (const bcLineControl in (formArray.controls[i] as UntypedFormGroup).controls) {
            if ((formArray.controls[i] as UntypedFormGroup).controls[bcLineControl].errors) {
              this.toastr.warning('Veuillez remplir le champ : ' + bcLineControl + ' de la ligne ' + i);
            }
          }
        }
      }
    }

  displayErrors(): void {
    for (const bc in this.bcForm.controls) {
      if (bc) {
        this.bcForm.controls[bc].markAsTouched();
      }
    }
  }

  calculateHorsTaxes(amount: any): void {
    if(amount && amount !== ''){
      this.bcLineHTs = amount;
      this.bcLineTTCs = amount;
    }else{
      this.bcLineHTs = 0;
      this.bcLineTTCs = 0;
    }
  }

  Change(withoutDoc: boolean): void{
    this.withoutDoc = withoutDoc;
  }

 
  getDesignationSelected(designationLib: string): void {
    this.articleLib = designationLib;
  }

  getSelectedCa1(object: any): void {
    this.ca1 = object;
  }

  getBcByIdAndSociety(): void {
    if (this.bcId) {
      this.getBcById(this.bcId).subscribe((bc: BcModel) => {
        if (bc != null && bc !== undefined) {
          this.bc = Object.assign({}, bc);
          this.checkDroits(this.bc)
          this.title.setTitle('SACHA - Modifier brouillon de BC ' + ( bc.fValide === NTHFlag.All ? bc.code : "Cxxxxxxxxxx"));     
          // récupérations des bcLines associés au bc en brouillon
          if (this.ifBcSocietyExistsInitializeForm(bc) !== null) {
            // Récupération de la société associée au BC grâce à son ID
            this.getAndSetSociety(this.bc.idSociete).subscribe((society: SocieteModel) => {

              this.setSociety(society);
              this.stateService.changeSociety(this.bc.societe);


              // Chargement des détails pour les autocompletes du BC
              this.subscriptions.push(this.bcComponentsService.loadDetailBc().subscribe((infos: DetailBcinfos) => {
                this.detailBcInfo = infos;
                if (this.bc?.idSociete != -1)
                  this.bcComponentsService.setLibelleCategorie(((this.bcForm.get('bcLines') as UntypedFormArray)).controls[0] as UntypedFormGroup);
                  this.bcComponentsService.loadDestination(0, ((this.bcForm.get('bcLines') as UntypedFormArray)).controls[0] as UntypedFormGroup);
              }));

              const today = new Date(Date.now());

              if (new Date(this.bc.dBc) < today) { this.bc.dBc = today; } // On est obligé de caster car il est initialisé au type string

              if (new Date(this.bc.dLivraison) < today) { this.bc.dLivraison = today; }

              this.bc.bcLines.forEach(line => {
                if (new Date(line.dLivraison) < today) { line.dLivraison = today; }
              });

              // Mise à jour du formulaire BC avec toutes les données récupérées.
              this.bcForm.patchValue(this.bc);
            });
          }
        }
      });
    }

  }

  checkDroits(bc: BcModel){
    const user = JSON.parse(localStorage.getItem('CURRENT_USER'));
    const droitsCreate = user.droits.filter(droit =>
        (droit.niveau === DefinitionDroitsBC.CREER) &&
        (droit.type.toUpperCase() === 'BC') && (droit.idSociete === bc.idSociete)
    );
      // vérification si droits de creation
    if ((!droitsCreate || droitsCreate.length <= 0)){
      this.router.navigate(['**']);
    }
  }

  checkIdParameter(): void {
    if (this.route.params !== undefined) {
      this.route.params.subscribe((params: any) => {
        if (params.id !== undefined) {
          this.bcId = params.id;
          this.bcService.get(params.id).subscribe(_ => { }, (error: ErrorEvent) => {
            this.router.navigate(['/not-found']);
            throw new Error('L\'élément demandé n\'existe pas').message;
          });
        }
      });
    }   
  }

  getBcById(bcId: number): Observable<BcModel> {
    return this.bcService.get(bcId);
  }

  ifBcSocietyExistsInitializeForm(bc: BcModel): any {
    if (bc.idSociete) {
      this.bcForm = this.bcComponentsService.getBrouillonBcEnveloppeFormGroup(bc);
      this.observableBc.next(this.bc);
    } else {
      return null;
    }
  }

  verifyBcStatusToRedirect(): void {
    if (this.observableBc) {
      this.observableBc.subscribe((bc: BcModel) => {
        if (bc) {
          if (bc.status !== 'Brouillon') {
            this.router.navigate(['/']);
            this.toastr.warning('Ce bon de commande a déjà été envoyé en validation.', 'Erreur');
          }
        }
      });
    }
  }

  openCycleValidation() {
    const dialog = this.dialog.open(ModalCycleValidationComponent, {
      data: {
        idBc: this.bc.id,
        idSociete: this.bc.idSociete,
        codeCa1: this.bcForm.get('codeCa1').value
      }
    });
  }
}


